export default "__VITE_ASSET__8Bi2fBXDUU9l1YHw65Yvzg__"